
import requests from "./api/api";

const FileService = {

    uploadFile:(body)=>requests.post('/file/v1/upload',body),

};

export default FileService;